import { render } from "./ProcessConformanceDrawerPanel.vue?vue&type=template&id=540be829&scoped=true"
import script from "./ProcessConformanceDrawerPanel.vue?vue&type=script&lang=js"
export * from "./ProcessConformanceDrawerPanel.vue?vue&type=script&lang=js"

import "./ProcessConformanceDrawerPanel.vue?vue&type=style&index=0&id=540be829&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540be829"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QSelect,QExpansionItem,QItem,QIcon});
